import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  AddAccountLink,
  OverviewLink,
  SearchLink,
  ContactUsLink,
  SettingsLink,
  LogoutLink,
  SignupLink,
  LoginLink
} from './links';

export default (isLoggedIn, isFullyLoggedIn, logout) => {
  const actions = [];

  if (isFullyLoggedIn) {
    actions.push(<AddAccountLink />, <OverviewLink />, <SearchLink />, <ContactUsLink />);
  }
  if (isLoggedIn) {
    actions.push(<SettingsLink />, <LogoutLink logout={logout} />);
  } else {
    actions.push(<LoginLink />, <SignupLink />);
  }
  return actions;
};



// WEBPACK FOOTER //
// ./src/my-app/nav-buttons.tsx